import { render, staticRenderFns } from "./TabCmp.vue?vue&type=template&id=47df37ff&"
import script from "./TabCmp.vue?vue&type=script&lang=js&"
export * from "./TabCmp.vue?vue&type=script&lang=js&"
import style0 from "./TabCmp.vue?vue&type=style&index=0&id=47df37ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports